// possible returns from apisauce (response.problem):
// Constant        VALUE               Status Code   Explanation
// ----------------------------------------------------------------------------------------
// NONE             null               200-299       No problems.
// CLIENT_ERROR     'CLIENT_ERROR'     400-499       Any non-specific 400 series error.
// SERVER_ERROR     'SERVER_ERROR'     500-599       Any 500 series error.
// TIMEOUT_ERROR    'TIMEOUT_ERROR'    ---           Server didn't respond in time.
// CONNECTION_ERROR 'CONNECTION_ERROR' ---           Server not available, bad dns.
// NETWORK_ERROR    'NETWORK_ERROR'    ---           Network not available.
// CANCEL_ERROR     'CANCEL_ERROR'     ---           Request has been cancelled. Only possible if `cancelToken` is provided in config, see axios `Cancellation`.
//
// Only try to handle messages from the server if CLIENT_ERROR

export const getErrorMessage = (
  serverResponse,
  defaultMessage = 'unknownError'
) => {
  console.log('getting error message for response: ', serverResponse);
  if (serverResponse.data) {
    if (serverResponse.data.devMsg) {
      console.log(serverResponse.data.devMsg);
    }
    return serverResponse.data.msg || defaultMessage;
  }
  switch (serverResponse.problem) {
    case 'SERVER_ERROR':
      // return i18n.t('serverError');
      return 'SERVER_ERROR';
    case 'TIMEOUT_ERROR':
      // return i18n.t('timedError');
      return 'TIMEOUT_ERROR';
    case 'CONNECTION_ERROR':
      // return i18n.t('connectionError');
      return 'CONNECTION_ERROR';
    case 'NETWORK_ERROR':
      return 'NETWORK_ERROR';
    // return i18n.t('networdError');
    case 'CANCEL_ERROR':
      // return i18n.t('cancelError');
      return 'CANCEL_ERROR';
    default:
      return defaultMessage;
  }
};



// WEBPACK FOOTER //
// ./src/services/Errors.js